// utils.js

/**
 * Returns the color associated with the given status and exclusion flag.
 * @param {string} status - The status of the item.
 * @param {boolean} excluded - Whether the item is excluded.
 * @returns {string} - The color corresponding to the status.
 */
export const getStatusColor = (status, excluded) => {
  if (excluded && excluded !="False") {
    return '#f2f2f2'; // Light gray
  }
  switch (status) {
    case 'Done':
      return "#b6ffc8"; // Green
    case 'Moderation':
      return '#d1f2e7'; // Yellow green-blue
    case 'Rendering':
      return '#d1e7dd'; // Light green
    case 'Sizes configuration':
      return '#d0e7ff'; // Light blue
    case 'Evaluation':
      return '#ebf5ff'; // Yellow
    case 'In progress':
      return '#fff5e9'; // Yellow
    case 'Ready for work':
      return '#e9d8fd'; // Purple
    case 'Bad product':
      return '#e2e3e5'; // Gray
    default:
      return 'white'; // Default white
  }
};
